import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EntityFormOptions } from '@common/classes/entity-form';
import { AppControlType } from '@common/components/app-control/app-control.component';
import { User } from '@common/models/User';

@Component({
    selector: 'app-vessel-notification-accompanied-grid',
    templateUrl: './vessel-notification-accompanied-grid.component.html',
    styleUrls: ['./vessel-notification-accompanied-grid.component.scss']
})
export class VesselNotificationAccompaniedGridComponent implements OnInit {
    @Input() accompanied: any;
    @Input() canEdit: boolean;
    @Input() editMode: any;
    @Input() tabs: Boolean;
    @Input() user: User;

    selectedTab: number;
    displayedAccompanied: any[];

    formOptions: EntityFormOptions = {
        entityName: 'VesselNotificationAccompanied',
        canEdit: () => this.canEdit,
        onRemove: () => this.filterAccompanied(),
        getCollection: () => this.accompanied,
        onAdd: () => this.filterAccompanied(),
        beforeAdd: model => {
            if (!this.user?.isSystemUser) model.ownerId = this.user?.organizationId || 0;

            model.createdDate = new Date();
            model.createdById = this.user?.id;
            model.createdOnTab = this.selectedTab;
        },
        propertyGroups: [
            [
                { name: 'accompanied', label: 'Attachment', type: AppControlType.File, colSize: 4 },
                { name: 'accompaniedTypeId', label: 'Attachment Type', type: AppControlType.CodeList, codelist: 'AttachmentType', colSize: 3 },
                { name: 'remarks', label: 'Remarks', maxlength: 255, colSize: 3 },
                { name: 'private', label: 'Private', type: AppControlType.Boolean, colSize: 2 }
            ]
        ]
    };

    constructor(private router: Router) { }

    ngOnInit(): void {
        if (this.user?.isSystemUser) {
            this.formOptions.propertyGroups.push([
                { name: 'ownerId', label: 'Owner', colSize: 3 }
            ]);
        }

        this.selectedTab = parseInt(this.router.routerState.snapshot.root.queryParams.vnTab, null);
        this.filterAccompanied();
    }

    filterAccompanied() {
        this.displayedAccompanied = this.tabs ? this.accompanied : this.accompanied.filter(a => a.createdOnTab === this.selectedTab);
    }
}
